import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=35f55eee&"
import script from "./Compass.vue?vue&type=script&lang=js&"
export * from "./Compass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f55eee')) {
      api.createRecord('35f55eee', component.options)
    } else {
      api.reload('35f55eee', component.options)
    }
    module.hot.accept("./Compass.vue?vue&type=template&id=35f55eee&", function () {
      api.rerender('35f55eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/components/Compass.vue"
export default component.exports